import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const EyeSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 95 95"
        enableBackground="new 0 0 95 95"
        xmlSpace="preserve"
      >
        <g>
          <path d="M47.5,69.562c18.482,0,34.436-9.017,41.892-22.062C81.936,34.455,65.982,25.438,47.5,25.438   c-18.481,0-34.436,9.017-41.892,22.062C13.064,60.545,29.019,69.562,47.5,69.562z M47.5,32.108c8.501,0,15.392,6.891,15.392,15.392   S56.001,62.892,47.5,62.892S32.108,56.001,32.108,47.5S38.999,32.108,47.5,32.108z" />
          <circle cx="42.642" cy="42.641" r="4.767" />
        </g>
      </svg>
    </div>
  );
};

EyeSVG.defaultProps = {
  color: getComputedCSSVariable('table-light-gray'),
  style: {
    width: '25px',
    height: '25px',
  },
};

export default EyeSVG;
